<template>
  <div>
    <!-- 表格 -->
    <el-table
      ref="TableListRef"
      class="TableList"
      border
      :data="list"
      v-loading="loading"
      v-on:[tableEvents.key]="tableEvents.e"
    >
      <el-table-column
        v-bind="{
          ...tableItemProps,
          ...publicProps,
          ...item
        }"
        v-for="item in showItem"
        :key="item.prop"
      >
        <template slot-scope="scope">
          <slot :name="item.prop" :data="scope.row">
            <span>{{ scope.row[item.prop] }}</span>
          </slot>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right" v-if="$scopedSlots.btn">
        <template slot-scope="scope">
          <slot name="btn" :data="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div :class="underPagination ? 'fenye' : ''" v-if="showPagination">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowTableInfo',

  props: {
    showPagination: {
      type: Boolean,
      default: true
    },

    showItem: {
      type: Array,
      default: () => []
    },

    underPagination: {
      type: Boolean,
      default: true
    },

    publicProps: {
      type: Object,
      default: () => {}
    },

    getListFn: {
      type: Function,
      default: () => {}
    },

    listKey: {
      type: String,
      default: 'list'
    },

    param: {
      type: Object,
      default: () => {}
    },

    paramChangeGetList: {
      type: Boolean,
      default: false
    },

    sortListFn: {
      type: Function,
      default: null
    },

    tableEvents: {
      type: Object,
      default: () => {
        return {
          key: 'e',
          e: () => {}
        }
      }
    }
  },

  data() {
    return {
      tableItemProps: {
        align: 'center'
      },

      list: [],

      total: 0,

      loading: false,

      query: {}
    }
  },

  watch: {
    param: {
      handler(newVal) {
        console.log('param', newVal)
        this.query = {
          ...this.query,
          ...newVal
        }

        if (this.paramChangeGetList) this.getList()
      },
      immediate: true,
      deep: true
    }
  },

  async mounted() {
    console.log('ShowTableInfo created', this.$props, this.$listeners, this.tableEvents)
    console.log('slot', this.$scopedSlots, this.$slots)
    this.getList()
  },

  methods: {
    async getList() {
      if (this.loading) return

      this.loading = true

      console.log('getList', this.query)

      try {
        const res = await this.getListFn(this.query)
        console.log('getListFn', res)

        if (this.listKey) {
          this.list = res.data[this.listKey]
          this.total = res.data.count
        } else {
          this.list = res.data
          this.total = res.count
        }

        if (this.sortListFn) {
          console.log('222222222222222')
          this.list = this.sortListFn(this.list)
        }

        if (this.$listeners.returnData) this.$emit('returnData', res.data)
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },
    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize
      this.query.pageSize = newSize
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage
      this.getList()
      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
